/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EFilterSearchType } from './EFilterSearchType';
import {
    EFilterSearchTypeFromJSON,
    EFilterSearchTypeFromJSONTyped,
    EFilterSearchTypeToJSON,
} from './EFilterSearchType';

/**
 * 
 * @export
 * @interface EFilterSearchTypeStringCombinableCriteria
 */
export interface EFilterSearchTypeStringCombinableCriteria {
    /**
     * 
     * @type {EFilterSearchType}
     * @memberof EFilterSearchTypeStringCombinableCriteria
     */
    searchMode?: EFilterSearchType;
    /**
     * 
     * @type {string}
     * @memberof EFilterSearchTypeStringCombinableCriteria
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EFilterSearchTypeStringCombinableCriteria
     */
    secondaryValue?: string | null;
}

/**
 * Check if a given object implements the EFilterSearchTypeStringCombinableCriteria interface.
 */
export function instanceOfEFilterSearchTypeStringCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EFilterSearchTypeStringCombinableCriteriaFromJSON(json: any): EFilterSearchTypeStringCombinableCriteria {
    return EFilterSearchTypeStringCombinableCriteriaFromJSONTyped(json, false);
}

export function EFilterSearchTypeStringCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EFilterSearchTypeStringCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EFilterSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
    };
}

export function EFilterSearchTypeStringCombinableCriteriaToJSON(value?: EFilterSearchTypeStringCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EFilterSearchTypeToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
    };
}

